import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Programs from "@/components/Programs";
import HowToDonate from "@/components/HowToDonate";
import DonateForm from "@/components/DonateForm";
import DonorWall from "@/components/DonorWall";
import Sponsor from "@/components/Sponsor";
import Faq from "@/components/Faq";
import Footer from "@/components/Footer";
import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error(err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen grid place-items-center bg-cream text-ink text-center p-8">
          <p className="font-display text-2xl font-black">Terjadi kesalahan — muat ulang halaman.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="bg-cream text-ink font-body min-h-screen overflow-x-clip">
        <div className="grain-overlay" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Programs />
          <HowToDonate />
          <DonateForm />
          <DonorWall />
          <Sponsor />
          <Faq />
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </ErrorBoundary>
  );
}

export default App;
